module.exports = "/assets/packs/images/fa89c2ad6034135519e9e99da17aaef5.png";